const GET_ASSET_SUB_TYPE = 'GET_ASSET_SUB_TYPE';
const SET_ASSET_SUB_TYPE = 'SET_ASSET_SUB_TYPE';

export
{
    GET_ASSET_SUB_TYPE,
    SET_ASSET_SUB_TYPE
};
